import { Button, Popconfirm, Tooltip } from 'antd';
import { useNavigate } from "react-router-dom";
import { EyeFilled, EditFilled, DeleteFilled, SignalFilled, MergeFilled } from '@ant-design/icons';
import chainIcon from "../../../Navbar/assets/chain.png"

const Columns = (hasPermission, showModal, handleDelete, filters, isSuperuser) => {
  const navigate = useNavigate();

  return [
    /* {
      title: "Código",
      dataIndex: "code",
      key: "code",
      sorter: (a, b) => a.code.localeCompare(b.code),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '10%',
    }, */
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      defaultFilteredValue: filters.dashboardAssetsFilter,
      filters: filters.assets.map(asset => ({
        text: asset.name,
        value: asset.name
      })),
      onFilter: (value, record) => record.name === value,
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '20%',
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '33%',
    },
    {
      title: "Responsable",
      dataIndex: "area",
      key: "area",
      sorter: (a, b) => (a.area?.name || '').localeCompare(b.area?.name || ''),
      defaultFilteredValue: filters.dashboardAreasFilter,
      filters: filters.areas.map(area => ({
        text: area.name,
        value: area.name
      })),
      onFilter: (value, record) => record.area?.name === value,
      render: (text, record) => record.area?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '12%',
    },
    {
      title: "Categoría",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category?.name || '').localeCompare(b.category?.name || ''),
      filters: filters.categories.map(category => ({
        text: category.name,
        value: category.name
      })),
      onFilter: (value, record) => record.category?.name === value,
      render: (category) => category?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '12%',
    },
    {
      title: "Creado por",
      dataIndex: "user",
      key: "user",
      sorter: (a, b) => {
        const usernameA = (a && a.user && a.user.username) ? a.user.username : "";
        const usernameB = (b && b.user && b.user.username) ? b.user.username : "";
        return usernameA.localeCompare(usernameB);
      },
      filters: filters.users.map(user => ({
        text: user.username,
        value: user.username
      })),
      onFilter: (value, record) => record.user?.username === value,
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      render: (user) => user?.username || "-",
      showSorterTooltip: false,
      width: '10%',
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => {
        const canUpdate = isSuperuser || hasPermission("assets", "update", record.area?.id);
        const canDelete = isSuperuser || hasPermission("assets", "delete", record.area?.id);
        const canViewDependencies = isSuperuser || hasPermission("dependencies", "read", record.area?.id);
        //const canViewAssignControls = isSuperuser || hasPermission("assignment", "read", record.area?.id);
        const canAssignment = isSuperuser || hasPermission("assignment", "create", record.asset?.area?.id);

        return (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
            <Button 
              type="link" 
              style={{ color: '#006939', fontSize: 18,  padding: '0px 4px' }} 
              onClick={() => navigate(`/assets/${record.code}`)}
            >
              <Tooltip title="Ver Activo"><EyeFilled /></Tooltip>
            </Button>
            <Button
              disabled={!canUpdate}
              style={{ color: canUpdate ? '#006939' : '#999999', fontSize: 18, padding: '0px 2px' }}
              type="link" 
              onClick={() => showModal(record)}>
              <Tooltip title="Editar Activo"><EditFilled /></Tooltip>
            </Button>
            <Button 
              type="link"
              disabled={!canViewDependencies}
              style={{ color: canViewDependencies ? '#F5A623' : '#999999', fontSize: 18, padding: '0px 2px' }}
              onClick={() => navigate(`/dependencies?asset=${encodeURIComponent(record.name)}`)}
            >
              <Tooltip title="Ver Dependencia">
                <span
                  style={{
                    display: "inline-block",
                    width: 16,
                    height: 16,
                    backgroundColor: canViewDependencies ? "#006939" : "#999999",
                    WebkitMask: `url(${chainIcon}) no-repeat center`,
                    WebkitMaskSize: "contain",
                    mask: `url(${chainIcon}) no-repeat center`,
                    maskSize: "contain"
                  }}
                />
              </Tooltip>
            </Button>
            <Button 
              type="link"
              disabled={!canAssignment}
              style={{ color: canAssignment ? '#F5A623' : '#999999', fontSize: 18, padding: '0px 2px' }}
              onClick={() => navigate(`/assignment?tab=1&asset=${encodeURIComponent(record.name)}`)}
            >
              <Tooltip title="Asignar Controles">
                <MergeFilled />
              </Tooltip>
            </Button>
            <Popconfirm 
              overlayClassName="custom-popconfirm"
              title="¿Seguro que deseas eliminar este Activo?"
              onConfirm={() => handleDelete(record.code)}
              disabled={!canDelete}
            >
              <Button 
                type="link"
                disabled={!canDelete}
                style={{ color: canDelete ? '#006939' : '#999999', fontSize: 18, padding: '0px 2px' }}
              >
                <Tooltip title="Eliminar Activo" placement='left'><DeleteFilled /></Tooltip>
              </Button>
            </Popconfirm>
          </div>
        )
      },
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', textAlign: 'center' } 
      }),
      align: 'center', 
      width: '11%',
    }  
  ];
};
  
export default Columns;
